<div class="partner">
    <div class="partner__hero-section">
        <app-hero-section [header]="header" [hasBtn]="hasBtn" [imagePath]="imagePath" [description]="description"
            [joinChat]="joinChat" [routerButton]="routerButton" [buttonText]="buttonText">
        </app-hero-section>
    </div>
    <section class="partner__steps-section">
        <div>
            <h2 l10nTranslate>Why Work With Us</h2>
            <div class="partner__steps_subtitle" l10nTranslate>We work with a focus in the field of governance, risk and
                compliance management, human risk management in the cyber security system We have a professional team
                that works passionately to build advanced products to meet the needs of our customers in developing
                their cyber defenses, and we work according to a professional methodology and roadmap for developing our
                products</div>
        </div>
        <div class="partner__steps-card">
            <div class="partner__steps-card-holder">
                <div class="partner__step-card">
                    <div class="partner__steps-card-content">
                        <img src="../assets/svg/Frame 48096948.svg" alt="">
                        <h6 [innerHTML]="'Expand Your Markets'" l10nTranslate></h6>
                    </div>
                </div>
            </div>
            <div class="partner__steps-card-holder">
                <div class="partner__step-card">
                    <div class="partner__steps-card-content">
                        <img src="../assets/svg/Frame480969481.svg" alt="">
                        <h6 [innerHTML]="'Differentiate Your Offering'" l10nTranslate></h6>
                    </div>
                </div>
            </div>
            <div class="partner__steps-card-holder">
                <div class="partner__step-card">
                    <div class="partner__steps-card-content">
                        <img src="../assets/svg/Frame 480969482.svg" alt="">
                        <h6 [innerHTML]="'Add New Revenue Streams'" l10nTranslate></h6>
                    </div>
                </div>
            </div>
        </div>
    </section>


    <section class="partner__Partnership-section">
        <div class="partner__Partnership-title-holder">
            <h2 l10nTranslate>Partnership That Works For All Types</h2>
        </div>
        <div class="partner__Partnerships-card">
            <div class="partner__Partnership-card-holder">
                <div class="partner__Partnership-card">
                    <div class="partner__Partnership-card-content">
                        <img src="../assets/svg/Frame480969486.svg" alt="">
                        <h2 [innerHTML]="'Managed Service Providers (MSPs)'" l10nTranslate></h2>
                    </div>
                </div>
            </div>
            <div class="partner__Partnership-card-holder">
                <div class="partner__Partnership-card">
                    <div class="partner__Partnership-card-content">
                        <img src="../assets/svg/Frame480969487.svg" alt="">
                        <h2 [innerHTML]="'Channel Value Added Resellers (VARs)'" l10nTranslate></h2>
                    </div>
                </div>
            </div>
            <div class="partner__Partnership-card-holder">
                <div class="partner__Partnership-card">
                    <div class="partner__Partnership-card-content">
                        <img src="../assets/svg/Frame480969488.svg" alt="">
                        <h2 [innerHTML]="'Cloud Service Providers (CSPs)'" l10nTranslate></h2>
                    </div>
                </div>
            </div>
        </div>
    </section>


    <section class="partner__competitive-section">
        <div class="partner__competitive-title-holder">
            <h2 l10nTranslate>Our Competitive Advantage</h2>
        </div>
        <div class="partner__competitive-row">
            <div class="partner__competitive-col">
                <div class="partner__competitive-col-title-holder">
                    <img src="../../../../assets/svg/new-product1.svg" alt="new-product">
                    <h2 l10nTranslate>Advanced Products That Meet The Requirements Of The Region's Markets</h2>
                </div>
            </div>
            <div class="partner__competitive-col">
                <div class="partner__competitive-col-title-holder">
                    <img src="../../../../assets/svg/new-product2.svg" alt="new-product">
                    <h2 l10nTranslate>Competitive Prices</h2>
                </div>
            </div>
            <div class="partner__competitive-col">
                <div class="partner__competitive-col-title-holder">
                    <img src="../../../../assets/svg/new-product3.svg" alt="new-product">
                    <h2 l10nTranslate>Flexibility In Development</h2>
                </div>
            </div>
            <div class="partner__competitive-col">
                <div class="partner__competitive-col-title-holder">
                    <img src="../../../../assets/svg/new-product4.svg" alt="new-product">
                    <h2 l10nTranslate>Professional Team</h2>
                </div>
            </div>
            <div class="partner__competitive-col">
                <div class="partner__competitive-col-title-holder">
                    <img src="../../../../assets/svg/new-product5.svg" alt="new-product">
                    <h2 l10nTranslate>Flexibility In The Cooperation Formula</h2>
                </div>
            </div>
            <div class="partner__competitive-col">
                <div class="partner__competitive-col-title-holder">
                    <img src="../../../../assets/svg/new-product6.svg" alt="new-product">
                    <h2 l10nTranslate>Local And Multi-Channel Support</h2>
                </div>
            </div>
            <div class="partner__competitive-col">
                <div class="partner__competitive-col-title-holder">
                    <img src="../../../../assets/svg/new-product7.svg" alt="new-product">
                    <h2 l10nTranslate>Full Support For The Arabic Language</h2>
                </div>
            </div>
            <div class="partner__competitive-col">
                <div class="partner__competitive-col-title-holder">
                    <img src="../../../../assets/svg/new-product8.svg" alt="new-product">
                    <h2 l10nTranslate>Connect With Various Systems</h2>
                </div>
            </div>
        </div>
    </section>

    <!-- <section>
        <div class="partner__our-partners">
            <div class="partner__our-partners-container">
                <div class="partner__our-partners-holder">
                    <div class="partner__our-partners-vector-holder">
                        <div class="partner__our-partners-vector"></div>
                        <img src="../../../../assets/images/Isolation_Mode.png" alt="Isolation">
                    </div>
                    <div class="partner__our-partners-row">
                        <div class="partner__our-partners-item">
                            <div class="partner__our-partners-text" l10nTranslate>Our Partners in Success</div>
                        </div>
                        <div class="partner__our-partners-item">
                            <img src="../../../../assets/svg/detasad.svg" alt="detasad">
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section> -->

    <!-- <section *ngIf="currentLanguage == 'en'" class="partner__form"> 
        <h2 l10nTranslate>Join Our Network Today</h2>
        <div class="pipedriveWebForms"
            data-pd-webforms="https://webforms.pipedrive.com/f/6rAtiVt3pMw2zEr4cbpZvVwQ9ybzPBFbYUBn8gd1XmGS9QKeDpgPbFr2SCQ7UjvdhF">
        </div>
    </section>
    <section *ngIf="currentLanguage == 'ar'" class="partner__form"> 
        <h2 l10nTranslate>Join Our Network Today</h2>
        <div class="pipedriveWebForms" data-pd-webforms="https://webforms.pipedrive.com/f/5VDVgv54YlCGP5828noLO698WTJQpExCYD9FF9RNYbD9rbjHsklU6WCbRPQC821mqT"><script src="https://webforms.pipedrive.com/f/loader"></script></div>
    </section> -->
        <div class="partner__form">
            <div *ngIf="currentLanguage == 'en'">
                <h2 l10nTranslate>Join Our Network Today</h2>
                <div style="position:relative; width:100%; height:0; padding-bottom:800px;">
                    <iframe 
                        src="https://solidrange.clickup.com/forms/9018770919/f/8crz1f7-26578/KQ1S26VUFJHOTAAQED"
                        style="position:absolute; top:0; left:0; width:100%; height:100%; border:none;"
                        allowfullscreen>
                    </iframe>
                </div>
            </div>
            <div *ngIf="currentLanguage == 'ar'">
                <h2 l10nTranslate>Join Our Network Today</h2>
                <div style="position:relative; width:100%; height:0; padding-bottom:800px;">
                    <iframe 
                        src="https://solidrange.clickup.com/forms/9018770919/f/8crz1f7-26598/RX47EGCDRFTP3MR3KP"
                        style="position:absolute; top:0; left:0; width:100%; height:100%; border:none;"
                        allowfullscreen>
                    </iframe>
                </div>
            </div>
        </div>
</div>